import { GeneralModel } from "./general.model";
import { AreaGroup } from "./areaGroup.model";
import { District } from "./district.model";
import { Province } from "./province.model";
import { Ward } from "./ward.model";

export class Area extends GeneralModel {
    areaGroupId: number;
    areaGroup: AreaGroup;
    districtIds: number[];
    wardIds: number[];
    provinceIds: number[];
    district: District;
    ward: Ward;
    province: Province;
    fromProvinceIds: number[];
    isAuto: boolean;
    priceServiceId: number;
}